"use strict";
/*---------------------------------------------------------------------------------------------
*  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
*--------------------------------------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.IEvent = void 0;
const ContentSantizer_1 = require("../Utils/ContentSantizer");
class IEvent {
    constructor() {
        this.isError = false;
    }
    getSanitizedProperties() {
        return (0, ContentSantizer_1.sanitizeProperties)(this.getProperties(true));
    }
}
exports.IEvent = IEvent;
//# sourceMappingURL=IEvent.js.map